import React, { useCallback, useState } from "react";

import { Skeleton } from "@packages/ds";
import { FormattedMessage } from "react-intl";

import * as Toast from "ds/Toast";
import { ToastVariant } from "ds/Toast";
import { useLocalForage } from "Hooks/useLocalForage";

import * as S from "./ProjectDetailsCard.styles";

export const ProvisioningProjectCard = ({
  projectId,
  projectName,
  projectIsInProvisioningFailure,
  isListView = false
}: {
  organizationId: string;
  projectId: string;
  projectName: string;
  refetchOrganizationProjectList: () => void;
  projectIsInProvisioningFailure: boolean;
  projectCreatedAt: string;
  isListView?: boolean;
}) => {
  const { value: isAlreadyClosed = false, setValue: setIsAlreadyClosed } =
    useLocalForage(`provisioning_failure_toast_${projectId}`);
  const [isOpenToast, setIsOpenToast] = useState(
    projectIsInProvisioningFailure ? !isAlreadyClosed : true
  );

  const handleToggleToast = useCallback(
    (newValue: boolean) => {
      if (newValue === false && !isAlreadyClosed) setIsAlreadyClosed(true);
      setIsOpenToast(newValue);
    },
    [isAlreadyClosed, setIsAlreadyClosed]
  );

  const toastPriority = projectIsInProvisioningFailure
    ? ToastVariant.error
    : ToastVariant.information;

  return (
    <>
      {!projectIsInProvisioningFailure &&
        (isListView ? (
          <S.ListItem>
            <div className="cell cell-project">
              <Skeleton.Square height="24px" width="188px" />
            </div>
            <div className="cell cell-region col-2">
              <Skeleton.Square height="24px" width="120px" />
            </div>
            <div className="cell cell-id col-2">
              <Skeleton.Square height="24px" width="120px" />
            </div>
          </S.ListItem>
        ) : (
          <S.CardWrapper>
            <Skeleton.Card>
              <S.Column>
                <Skeleton.Square height="24px" width="120px" />
                <Skeleton.Square height="24px" width="368px" />
              </S.Column>
            </Skeleton.Card>
          </S.CardWrapper>
        ))}
      <Toast.Provider duration={Infinity}>
        <Toast.Root open={isOpenToast} onOpenChange={handleToggleToast}>
          <Toast.Icon variant={toastPriority} />
          <Toast.Content>
            <Toast.Title>
              <FormattedMessage
                id={`tooltip.projectCreation.${toastPriority}`}
                values={{
                  projectName
                }}
              />
            </Toast.Title>
            <Toast.Close aria-label="Close" />
          </Toast.Content>
        </Toast.Root>
        <S.ToastViewport />
      </Toast.Provider>
    </>
  );
};
